// src/utils/createProfile.js
// Creates the Firestore profile through the usersCreateUserProfile function.
// The server decides credits, role and verification; the client only sends
// consent, CEP, device info and the signup campaign (validated server-side).
import { getOrCreateDeviceId, getIpAddress } from './helpers';
import { functionUrl } from '../firebase';

const CAMPAIGN_KEY = 'escambo.signupCampaignId';
const CREATING_KEY = 'escambo.creatingProfile';

/** Remembers the landing-page campaign across the Google popup / redirect. */
export const rememberSignupCampaign = (campaignId) => {
    try {
        if (campaignId) sessionStorage.setItem(CAMPAIGN_KEY, campaignId);
    } catch (e) { /* storage unavailable: campaign simply not applied */ }
};

const readSignupCampaign = () => {
    try { return sessionStorage.getItem(CAMPAIGN_KEY); } catch (e) { return null; }
};

/** True while this tab is creating a profile (useAuth waits instead of asking to complete signup). */
export const isCreatingProfile = () => {
    try { return sessionStorage.getItem(CREATING_KEY) === '1'; } catch (e) { return false; }
};
export const markCreatingProfile = (on) => {
    try {
        if (on) sessionStorage.setItem(CREATING_KEY, '1');
        else sessionStorage.removeItem(CREATING_KEY);
    } catch (e) { /* ignore */ }
};

export async function createProfile(user, { cep = '', campaignId = null } = {}) {
    const idToken = await user.getIdToken(true);
    const deviceId = getOrCreateDeviceId();
    const ipAddress = await getIpAddress();
    const signupCampaignId = campaignId || readSignupCampaign();

    const newUserProfileData = {
        uid: user.uid,
        cep: cep || '',
        signupDeviceInfo: { deviceId, ipAddress: ipAddress || 'not_found' },
        termsAgreement: { agreed: true },
        ageConfirmation: { confirmed: true },
        ...(signupCampaignId ? { signupCampaignId } : {}),
    };

    const response = await fetch(functionUrl('usersCreateUserProfile'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
        body: JSON.stringify({ data: { newUserProfileData } }),
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(`Falha ao criar o perfil: ${text}`);
    }
    try { sessionStorage.removeItem(CAMPAIGN_KEY); } catch (e) { /* ignore */ }
    return response.json();
}
